export default "__VITE_ASSET__5f4ede17__"